
<div
  id="alert-bubble"
  class="tooltip-alert"
  :class="tooltipClasses"
>
  <div class="bubble" v-bind:style="`background-color: ${gColors(color).hex}`">
    <h6><icon glyph="help-circle"/> {{title}}</h6>
    <slot/>
    <div class="tooltip-cta">
      <button
        class="btn white"
        v-bind:style="`color: ${gColors(color).hex}`"
        v-on:click="removeTooltip">Got it</button>
  </div>
  </div>
</div>
